// extracted by mini-css-extract-plugin
module.exports = {"h1":"h1___1p4lm","h2":"h2___2rBYR","h3":"h3___3Yd8o","h4":"h4___3YU0_","h5":"h5___yFVmr","p":"p___3cq5i"};